import once from 'lodash/once';
import { createContext, useContext } from 'react';

import { AppModal, AppModalType } from 'app/types/appModal.types';

import { AppModalContextValue } from './appModalContext.types';

export const createAppModalContext = once(<
  TAppModalType extends AppModalType,
>() =>
  createContext<AppModalContextValue<TAppModalType, AppModal>>(undefined!),
);

/**
 * A hook to access the state of a given modal.
 *
 * @example
 *   const { isOpen, modal, hide } = useAppModal('my-modal');
 */
export const useAppModal = <TAppModalType extends AppModalType>(
  _type: TAppModalType,
): AppModalContextValue<TAppModalType, AppModal> =>
  useContext(createAppModalContext<TAppModalType>());
